import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTransferArrowLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 9,
	height: 13,
	viewBox: "0 0 9 13",
	fill: "#FF2700",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8 10.81L8 2.18996C8 1.33304 6.99264 0.873048 6.34507 1.43427L1.37195 5.74431C0.911857 6.14306 0.911858 6.85694 1.37195 7.25569L6.34507 11.5657C6.99264 12.127 8 11.667 8 10.81Z",
		fill: "#FF2700"
	})
});
export default SvgTransferArrowLeft;
